const ufeApi = require('services/api/ufeApi');
const basketUtils = require('utils/Basket');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Remove+Promotion+API

function removePromotion(orderId, couponCode) {
    const Location = require('utils/Location.js');
    const queryParams = [];
    const params = { orderId };

    let url = '/api/shopping-cart/baskets/' + orderId + '/promotions';
    if (Location.isCheckout()) {
        queryParams.push('is_from_checkout=true');
    }
    if (basketUtils.isPickup()) {
        queryParams.push('promoBasket=PICKUP');
    }

    if (couponCode) {
        queryParams.push(`couponCode=${couponCode}`);
        params.couponCode = encodeURIComponent(couponCode);
    }

    if (queryParams.length) {
        url += '?' + queryParams.join('&');
    }

    return ufeApi.makeRequest(url, {
        method: 'DELETE',
        body: JSON.stringify(params)
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = removePromotion;
